/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Grid/search result color swatches show every color option ever added to
  // a product, including discontinued ones. The product page already hides
  // discontinued colors using two metafields: metafields.custom.core_colors
  // and metafields.custom.seasonal_colors (comma separated lists of the
  // colors still sold). This makes the grid/search swatches match, for any
  // product that has one of those metafields set. Products without them are
  // left completely untouched.
  (function () {
  function parseColorList(value) {
  if (!value) return [];
  return value.split(',').map(function (color) {
  return color.trim().toLowerCase();
  }).filter(Boolean);
  }

  function isColorSwatchGroup(holder) {
  var label = (holder.getAttribute('data-swatch-label') || '').trim().toLowerCase();
  return label === '' || label === 'color' || label === 'colors';
  }

  function filterSwatchHolder(holder, allowedColors) {
  var links = holder.querySelectorAll('.swatch__link');
  if (!links.length) return false;
  var removedCount = 0;
  links.forEach(function (link) {
  var name = (link.getAttribute('data-swatch') || link.textContent || link.getAttribute('aria-label') || link.getAttribute('data-tooltip') || '').replace(/^color:\s*/i, '').trim().toLowerCase();
  if (name && allowedColors.indexOf(name) === -1) {
  var button = link.closest('.swatch__button') || link;
  if (button.parentNode) button.parentNode.removeChild(button);
  removedCount++;
  }
  });
  if (removedCount > 0) {
  var card = holder.closest('[data-product-grid-item]');
  var countLabel = card && card.querySelector('.product-item__swatches__count');
  if (countLabel) {
  var remaining = holder.querySelectorAll('.swatch__link').length;
  var suffix = countLabel.textContent.match(/colou?rs?/i);
  countLabel.textContent = remaining + ' ' + (suffix ? suffix[0] : 'colors');
  }
  }
  return true;
  }

  function watchSwatchHolder(holder, allowedColors, onSettled) {
  var settled = false;
  function trySettle() {
  if (settled) return;
  if (filterSwatchHolder(holder, allowedColors)) {
  settled = true;
  observer.disconnect();
  onSettled();
  }
  }
  var observer = new MutationObserver(trySettle);
  observer.observe(holder, { childList: true, subtree: true });
  trySettle();
  setTimeout(function () {
  if (!settled) {
  observer.disconnect();
  onSettled();
  }
  }, 2000);
  }

  function init() {
  var cards = document.querySelectorAll('[data-product-grid-item]');
  cards.forEach(function (card) {
  var core = parseColorList(card.getAttribute('data-core-colors'));
  var seasonal = parseColorList(card.getAttribute('data-seasonal-colors'));
  var allowedColors = core.concat(seasonal);
  if (!allowedColors.length) return;
  var colorHolders = [];
  card.querySelectorAll('[data-grid-swatches]').forEach(function (holder) {
  if (isColorSwatchGroup(holder)) colorHolders.push(holder);
  });
  if (!colorHolders.length) return;
  var pending = colorHolders.length;
  function settleOne() {
  pending--;
  if (pending <= 0) card.classList.add('swatch-filter-ready');
  }
  colorHolders.forEach(function (holder) {
  watchSwatchHolder(holder, allowedColors, settleOne);
  });
  });
  }

  if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
  } else {
  init();
  }
  })();


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
